import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/agenda")({
  component: () => (
    <div className="flex min-h-screen flex-col">
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  ),
});
